import React, { useState } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import WhatsAppButton from '../WhatsAppButton/WhatsAppButton';
import InfoModal from '../InfoModal/InfoModal';

const Layout = ({ children, whatsappLink }) => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const openInfoModal = () => setIsInfoModalOpen(true);
  const closeInfoModal = () => setIsInfoModalOpen(false);

  return (
    <div className="App">
      <Header openInfoModal={openInfoModal} />
      <main>{children}</main>
      <Footer openInfoModal={openInfoModal} />
      <WhatsAppButton whatsappLink={whatsappLink} />
      <InfoModal isOpen={isInfoModalOpen} onClose={closeInfoModal} />
    </div>
  );
};

export default Layout;
